import {api} from '../../config';
import {httpPostJson} from './http';

export type LoginRequestBody = {
  email: string;
  password: string;
};

export type LoginSuccessResponse = {
  authTokens: {
    'X-ITKT-TOKEN': string;
    'X-ATKT-TOKEN': string;
  };
  accountId?: number;
};

export function composeLogin(baseUrl = '') {
  return (body: LoginRequestBody, turnstileToken?: string) =>
    httpPostJson<LoginSuccessResponse>({
      path: `${baseUrl}${api.mpApiClient}/me/login`,
      body: {...body, cookies: true},
      options: {
        headers: {
          'x-forwarded-host': window.location.host,
          ...(turnstileToken ? {'x-cf-turnstile-token': turnstileToken} : {}),
        },
      },
    });
}

export const login = composeLogin();
